export default "__VITE_ASSET__1a87b8f0__"